import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import useQueryOrganizationById from "./useQueryOrganizationById.js";

export default function EmployerItem(props) {
  const { organizationId } = props;

  const { data: organization, loading, errors } = useQueryOrganizationById(organizationId);

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => organization.company
        }
      />
    </HorizontalLoader>
  );
}
